module.exports = __webpack_public_path__ + "img/bookmark-x.ed591238.svg";